module.exports = __webpack_public_path__ + "assets/rosette-surprise-key-button.b42736c8.svg";